const introSlider = new Swiper(".intro__slider", {
  slidesPerView: "auto",
  speed: 500,
  spaceBetween: 30,
  loop: true,
  centeredSlides: true,
  initialSlide: 0,
  loopedSlides: 1,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      spaceBetween: 50,
    },
  },
});

const meritSlider = new Swiper(".merit__slider", {
  slidesPerView: 1.1,
  speed: 500,
  spaceBetween: 20,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 1.5,
      spaceBetween: 50,
    },
  },
});

const voice__slider = new Swiper(".voice__slider", {
  slidesPerView: 1.1,
  speed: 500,
  spaceBetween: 20,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".swiper-pagination",
    // clickable: true, 無効化
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 1.5,
      spaceBetween: 50,
    },
  },
});



const acc_ttl2 = Array.from(document.querySelectorAll(".materials__item--title"));
const acc_ttl3 = Array.from(document.querySelectorAll(".faq__item--title"));

// スマホ判定関数（例：768px以下）
function isMobile() {
  return window.innerWidth <= 768;
}

if (isMobile()) {
  for (let i = 0; i < acc_ttl2.length; i++) {
    let ttl = acc_ttl2[i];
    let content = ttl.nextElementSibling;

    // 初期状態で閉じたまま
    content.style.height = "0";
    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease";

    ttl.addEventListener("click", () => {
      const isOpen = ttl.classList.contains("active");

      ttl.classList.toggle("active");

      if (isOpen) {
        content.style.height = content.scrollHeight + "px";
        requestAnimationFrame(() => {
          content.style.height = "0";
        });
      } else {
        content.style.height = content.scrollHeight + "px";
        content.addEventListener(
          "transitionend",
          function handler() {
            content.style.height = "auto";
            content.removeEventListener("transitionend", handler);
          }
        );
      }
    });
  }
  for (let i = 0; i < acc_ttl3.length; i++) {
    let ttl2 = acc_ttl3[i];
    let content2 = ttl2.nextElementSibling;

    // 初期状態で閉じたまま
    content2.style.height = "0";
    content2.style.overflow = "hidden";
    content2.style.transition = "height 0.3s ease";

    ttl2.addEventListener("click", () => {
      const isOpen = ttl2.classList.contains("active");

      ttl2.classList.toggle("active");

      if (isOpen) {
        content2.style.height = content2.scrollHeight + "px";
        requestAnimationFrame(() => {
          content2.style.height = "0";
        });
      } else {
        content2.style.height = content2.scrollHeight + "px";
        content2.addEventListener(
          "transitionend",
          function handler() {
            content2.style.height = "auto";
            content2.removeEventListener("transitionend", handler);
          }
        );
      }
    });
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const fv = document.querySelector('.js-fv');
  const header = document.querySelector('.or__header');

  const fvHeight = fv.offsetHeight;

  window.addEventListener('scroll', () => {
    if (window.scrollY > fvHeight) {
      header.classList.add('is_active');
    } else {
      header.classList.remove('is_active');
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const info = document.querySelector(".information");
  const footer = document.querySelector(".footer"); // フッターのセレクタは調整

  if (info && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // footerが見えたら非表示
            info.classList.add("is-hidden");
          } else {
            // footerから離れたら再表示
            info.classList.remove("is-hidden");
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );

    observer.observe(footer);
  }
});


window.addEventListener("scroll", function () {
  const infoLink = document.querySelector(".information");
  if (!infoLink) return; // 念のため存在確認

  if (window.scrollY > 0) {
    infoLink.classList.add("is_active");
  } else {
    infoLink.classList.remove("is_active");
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".why__item, .habit__item, .habit__contents h2");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        // 一度だけでOKなら監視解除
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 }); // 20%見えたら発火

  targets.forEach(el => observer.observe(el));
});